"use strict";

/**
 * 字符串转时间戳
 * @param str
 * @param mode
 * **** 0 yyyy-mm-dd hh:ii:ss
 * @returns {*}
 */
module.exports = function (str) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!str) return "";
  switch (mode) {
    case 0:
      //yyyy-mm-dd hh:ii:ss
      var arr1 = str.split(/[\s-:]+/);
      arr1 = arr1.slice(0, 6).map(function (r) {
        return parseInt(r);
      });
      var t1 = new Date(arr1[0], arr1[1] - 1, arr1[2], arr1[3], arr1[4], arr1[5]);
      console.log('时间', t1.toLocaleString());
      return t1.getTime();
      break;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ty-vue-filters@1.0.22@ty-vue-filters/dist/filters/str2time.js
// module id = JUxi
// module chunks = 300